define('views/parts/form/textarea-advanced',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'summernote',
    // Services
    'services/i18n',
    // collections
    'collections/conversation/custom-messages',
    // templates
    'text!templates/parts/form/textarea.html',

], function(
    // Libs
    _, Backbone, Mustache, U, Summernote,
    // services
    i18n,
    // collections
    CCustomMessages,
    // templates
    TPartsFormTextareaAdvanced
) {

    /**
     * Creates an input box with an inline dynamic label
     * and provides two-way binding via Epoxy.
     *
     * @param  {string} label
     * @param  {string} labelposition [inner|left|top]
     * @param  {string} attribute of the model
     * @param  {string} name of the input element
     * @param  {string} id of the input element
     */
    var VTextareaAdvanced = Backbone.Epoxy.View.extend({

        template: TPartsFormTextareaAdvanced,
        events: {
            'focus textarea': 'onTextareaFocus',
            'blur textarea': 'onTextareaBlur',
            'input textarea': 'onTyping',
        },
        regions: {
            label: ".control-label",
            textarea: ".form-control"
        },

        initialize: function(opt) {
            var model = this.model,
                options = this.options = _.extend({
                    attribute: 'value',
                    name: opt.attribute,
                    id: this.cid,
                    labelposition: 'inner',
                    autosize: false
                }, opt);

            if (!model) {
                this.model = model = new Backbone.Model();
                model.set(options.attribute, null);
            }

            if (options.labelposition === "inner") {
                options.inner = true;
            }

            this.listenTo(this.model, "change:" + options.attribute, this.updateLabel);

        },
        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.options, this.options.namespace));
            this.$el.empty().append(html);
            this.applyBindings();

            this.generateZones();

            this.updateLabel();
            this.setTextareaHeight(true);

            this.setEditor();

            var self = this;

            Backbone.$(this.zone.$textarea).on("summernote.change", function() {
                self.model.set(self.options.attribute, self.zone.$textarea.summernote('code'));
            });

            return this;
        },

        getValue: function() {
            return this.zone.$textarea.summernote('code');
        },

        setValue: function(value) {
            return this.zone.$textarea.summernote('code', value);
        },

        updateLabel: function() {
            if (this.zone && this.zone.$label) {
                var val = this.model.get(this.options.attribute);
                this.toggleLabel(_.isNumber(val) || !_.isEmpty(val));
            }
        },

        toggleLabel: function(val) {
            this.zone.$label.toggleClass("label-to-top", val);
        },

        setTextareaHeight: function(init) {
            var textarea = this.zone.$textarea[0];
            if (!textarea) textarea = this.zone.$textarea;

            if (Backbone.$(textarea).val()) {
                if (Backbone.$(textarea).val().length > 0 && Backbone.$(textarea).hasClass('autosize')) {
                    textarea.style.height = 'auto';
                    textarea.style.height = textarea.scrollHeight + 'px';
                }
            }
        },

        setEditor: function() {

            var self = this;

            this.zone.$textarea.summernote({
                dialogsInBody: true,
                toolbar: this.options.toolbar ? this.options.toolbar : [
                    ['style', ['bold', 'italic', 'underline']],
                    ['customButtons', ['messagesTemplate']]
                ],
                buttons: _.extend(this.options.buttons, {
                    messagesTemplate: this.createMessagesButton(self)
                }),
                disableDragAndDrop: true,
                height: self.options.height,
                minHeight: self.options.height,
                maxHeight: self.options.height,
                callbacks: {
                    onPaste: function(e) {
                        var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        e.preventDefault();
                        setTimeout(function() {
                            document.execCommand('insertText', false, bufferText);
                        }, 10);
                    },
                    onInit: function() {
                        // console.log('Summernote is launched');
                    }
                }
            });
        },

        addEditorMessage: function(title, message) {
            // TODO: Add message to collection (Save)
            this.editorMessages.push({
                title: title,
                value: message
            });

            return this.editorMessages;
        },

        getEditorMessages: function() {
            if (!this.editorMessages) {
                this.editorMessages = [];
                var cCustomMessages = new CCustomMessages();
                cCustomMessages.fetch({
                    async: false,
                    success: _.bind(function(collection, response, options) {
                        cCustomMessages.each(_.bind(function(model, index, list) {
                            this.editorMessages.push({ title: model.get('title'), value: model.get('message') });
                        }, this));
                    }, this),
                    error: function() {
                        this.editorMessages.push({ title: i18n.t("conversation:An error occur while retreiving your custom message"), value: "" });
                    }
                });

                if (this.editorMessages.length === 0) {
                    this.editorMessages.push({ title: i18n.t("conversation:There is no custom message to display"), value: "" });
                }
            }

            return this.editorMessages;

        },

        getEditorMessagesHTML: function() {
            var messages = this.getEditorMessages();
            var html = "";

            Backbone.$(messages).each(function(k, v) {
                html += "<li><a href='#' dataValue='" + k + "' onclick='return false;'>" + this.title + "</a></li>";
            });

            return html;
        },

        createMessagesButton: function(context, btnTrad) {

            if (!this.isSupervisor()) {
                return;
            }

            var editorMessagesHTML = this.getEditorMessagesHTML();
            var editorMessages = this.editorMessages;
            var ui = Backbone.$.summernote.ui;
            var self = this;

            var customMessageButtonGroup = ui.buttonGroup([
                ui.button({
                    className: 'dropdown-toggle ',
                    contents: i18n.t("conversation:Your Messages") + ' <span class="caret"></span>',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                ui.dropdown({
                    className: 'dropdown-menu scrollable-menu five-rows',
                    contents: editorMessagesHTML,
                    callback: function($dropdown) {
                        $dropdown.find('li').each(function() {
                            Backbone.$(this).click(function() {
                                var itemNum = Backbone.$('a', this).attr('dataValue');
                                var text = editorMessages[itemNum];

                                text.value = text.value.replace(/(?:\r\n|\r|\n)/g, '<br />');
                                self.zone.$textarea.summernote('code', text.value);
                            });
                        });
                    }
                })
            ]);

            return customMessageButtonGroup.render();
        },

        destroyEditor: function() {
            this.zone.$textarea.summernote('destroy');
        },

        isSupervisor: function() {
            // if (this.options.group === undefined) {
            //     return false;
            // } else {
            //     return this.options.group.isSupervisor();
            // }
            return true;
        },

        // form events
        onTextareaFocus: function(e) {
            this.zone.$label.addClass("focus");
            this.toggleLabel(true);
        },

        onTextareaBlur: function(e) {
            var zone = this.zone,
                $textarea = zone.$textarea,
                value = this.getValue();
            zone.$label.removeClass("focus");
            this.toggleLabel(value === "" || value === null);

        },

        onTyping: function(e) {
            this.setTextareaHeight();
        },

        toggleDisabled: function(val) {
            this.zone.$textarea.toggleDisabled(val);
        },

        onSubmit: function() {
            var options = this.options,
                context = options.context || this,
                model = this.model,
                value = this.zone.$textarea.summernote('code');

            model.set(options.attribute, value);

            _.callback(context, options.callback, [model, value]);

            this.trigger("submit", model, value);

            this.zone.$textarea.summernote('code', '');
        },

    });

    return VTextareaAdvanced;

});

